import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { useStyles, styles } from '../TrainingScreenStyles';
import { Icon, Table, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import * as TrainingActions from '../../../actions/TrainingActions';

const TableScreen = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)

    const {
        listTraining,
        isLoadListTraining,
        pagination,
        filter
    } = useSelector(state => state.TrainingReducer);

    const { current, pageSize, total } = pagination;

    const dataSource = listTraining.map(
        (record) => {
            return {
                'key': record.idTraining,
                'idTraining': record.idTraining,
                'trainingName': record.trainingName,
                'canDelet': record.canDelet
            }
        }
    );

    const paginationTable =
    {
        defaultCurrent: 1,
        defaultPageSize: 25,
        current: current,
        pageSize: pageSize,
        total: total,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '100'],
        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
    }

    const handleTableChange = (pagination, filters, sorter) => {

        dispatch(TrainingActions.fetchTraining({
            offset: (pagination.current - 1) * pagination.pageSize,
            limit: pagination.pageSize,
            sortColumn: Object.keys(sorter).length > 0 ? sorter.field : undefined,
            sortDir: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined,
            listIdTraining: props.FiltroNombre.join(','),//filter.listNames.length > 0 ? filter.listNames.join(",") : undefined,
            listSubdirection: filter.listSubdirections.length > 0 ? filter.listSubdirections.join(",") : undefined
        }))
    }

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'trainingName',
            key: 'trainingName',
            sorter: true,
            ellipsis: true
        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idTraining',
            fixed: 'right',
            width: 120,
            render: (text, record) => (
                <div className={classes.buttons}>
                    <Tooltip title="Asignar administrador">
                        <IconButton onClick={() => props.assignManage(record)}>
                            <Icon type="schedule" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                        <IconButton disabled={record.trainingName === 'Sistemas' || record.trainingName === 'Disciplina Operacional' || !record.canDelet} className={classes.deleteIcon} onClick={() => props.showConfirmDelete(record)}>
                            <Icon type="delete" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Editar">
                        <IconButton disabled={record.trainingName === 'Sistemas' || record.trainingName === 'Disciplina Operacional'} className={classes.editIcon} onClick={() => props.editTraining(record)}>
                            <Icon type={siteId === "HUB" ? "edit" : "eye"} />
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <Table
            loading={isLoadListTraining}
            columns={columns}
            dataSource={dataSource}
            pagination={paginationTable}
            // scroll={{ y: 700, x: "max-content" }}
            scroll={{ x: 'min-content', y: (height - 395) }}
            size={"small"}
            onChange={handleTableChange}
        />
    )
}

export default TableScreen;
